module.exports = __webpack_public_path__ + "assets/img/1775-cw.svg";